export const ANTHOR = {
  type: "anthor",
  payload: ''
};
export const ISEXIT = {
  type: "isExit",
  payload: ''
};
